import React, { useEffect, useState } from 'react'
import useFullPageLoader from '../../hooks/useFullPageLoader'
import { generateMonthsWithFilterRange, ShowMonthList } from './components/commons'
import { ConsultantPayoutMonthCMP } from './components/Months-Listing';
import ConsultantWallet from './components/ConsultantWallet';
import BankPanManagement from './components/BankPanManagement';
import { toast } from 'sonner';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { getWalletPayoutVisibility } from '../../services/consultantPayout'


export default function ConsultantPayout() {

  const { rightsInfo, role } = useSelector((state) => state?.vedicRights);
  const isAdmin = String(role || '').trim().toLowerCase() === 'admin';
  const canViewPayout = isAdmin || rightsInfo?.['consultant-payout-management'] === true;
  const canViewBankPanRequest = isAdmin || rightsInfo?.['bank-pan-request-management'] === true;
  const canViewBankPanRecord = isAdmin || rightsInfo?.['bank-pan-record-management'] === true;
  const canViewBankPan = canViewBankPanRequest || canViewBankPanRecord;
  const [loader, showLoader, hideLoader] = useFullPageLoader()
  const { currentMonth, monthList } = generateMonthsWithFilterRange();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth || null);
  const [isVeriedScreen, setIsVeriedScreen] = useState(false);
  const [activeTab, setActiveTab] = useState(
    canViewPayout ? 'wallet' : 'bankPan'
  ); // 'payout', 'wallet', or 'bankPan'
  const [walletVisibility, setWalletVisibility] = useState(null);

  const loadWalletVisibility = async () => {
    try {
      const response = await getWalletPayoutVisibility();
      if (response.data?.success) {
        setWalletVisibility(response.data.result || null);
      }
    } catch (error) {
      console.log('wallet visibility fetch failed', error);
    }
  };

  useEffect(() => {
    if (canViewPayout) {
      loadWalletVisibility();
    }
  }, [canViewPayout]);

  useEffect(() => {
    // if (currentMonth.monthName !== selectedMonth.monthName) {
    //   console.log('selectedMonth :: ', selectedMonth)
    // }
  }, [selectedMonth]);

  useEffect(() => {
    if ((activeTab === 'payout' || activeTab === 'wallet') && !canViewPayout && canViewBankPan) {
      setActiveTab('bankPan');
    } else if ((activeTab === 'bankPan' && !canViewBankPan && canViewPayout) || (activeTab === 'bankPanRequests' && !canViewBankPanRequest && canViewPayout)) {
      setActiveTab('wallet');
    }
  }, [activeTab, canViewPayout, canViewBankPan, canViewBankPanRequest]);

  return (
    <div>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox" style={{ position: 'relative' }}>
          {!isVeriedScreen && <FullScreen verifiedScreen={() => setIsVeriedScreen(true)} />}
          
          {/* Tab Navigation */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', gap: 8, borderBottom: '1px solid #eee' }}>
              {canViewPayout && <button
                onClick={() => setActiveTab('payout')}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === 'payout' ? '#ff8989' : 'transparent',
                  color: activeTab === 'payout' ? 'white' : '#666',
                  cursor: 'pointer',
                  borderRadius: '4px 4px 0 0',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
              >
                Payout Management
              </button>}
              {canViewPayout && <button
                onClick={() => setActiveTab('wallet')}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === 'wallet' ? '#ff8989' : 'transparent',
                  color: activeTab === 'wallet' ? 'white' : '#666',
                  cursor: 'pointer',
                  borderRadius: '4px 4px 0 0',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
              >
                Payout
              </button>}
              {canViewBankPan && <button
                onClick={() => setActiveTab('bankPan')}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === 'bankPan' ? '#ff8989' : 'transparent',
                  color: activeTab === 'bankPan' ? 'white' : '#666',
                  cursor: 'pointer',
                  borderRadius: '4px 4px 0 0',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
              >
                Bank PAN Management
              </button>}
              {canViewBankPanRequest && <button
                onClick={() => setActiveTab('bankPanRequests')}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === 'bankPanRequests' ? '#ff8989' : 'transparent',
                  color: activeTab === 'bankPanRequests' ? 'white' : '#666',
                  cursor: 'pointer',
                  borderRadius: '4px 4px 0 0',
                  fontWeight: '500',
                  transition: 'all 0.3s ease'
                }}
              >
                Bank PAN Requests
              </button>}
            </div>
          </div>

          {activeTab === 'payout' && canViewPayout ? (
            <div style={{ display: 'flex', gap: 12 }}>
              <ShowMonthList
                currentMonth={currentMonth}
                monthList={monthList}
                selectedMonth={selectedMonth}
                setSelectedMonth={setSelectedMonth}
                walletVisiblePeriod={walletVisibility?.showOnWallet ? walletVisibility?.period : ''}
              />
              <div style={{ flex: 1, overflow: 'scroll' }}>
                {currentMonth && selectedMonth ? (
                  <div>
                    <ConsultantPayoutMonthCMP
                      selectedMonth={selectedMonth}
                      walletVisibility={walletVisibility}
                      onWalletVisibilityChange={setWalletVisibility}
                    />
                  </div>
                ) : (
                  <div style={{ padding: 16 }}>
                    <p>Please select a month to view payout details.</p>
                  </div>
                )}
              </div>
            </div>
          ) : activeTab === 'wallet' && canViewPayout ? (
            <ConsultantWallet />
          ) : activeTab === 'bankPanRequests' && canViewBankPanRequest ? (
            <BankPanManagement
              canViewRequest={true}
              canViewRecord={false}
              requestsOnly
            />
          ) : canViewBankPan ? (
            <BankPanManagement
              canViewRequest={canViewBankPanRequest}
              canViewRecord={canViewBankPanRecord}
            />
          ) : (
            <p>You do not have permission to view this section.</p>
          )}
        </div>
      </div>
    </div>
  )
}


const FullScreen = ({ verifiedScreen }) => {
  const [accessCode, setAccessCode] = useState('');
  verifiedScreen();
  const verifyAccess = () => {
    if (accessCode === 'XaFuGT^PUUh$Pq5P') {
      verifiedScreen();
    } else {
      toast.error('Invalid access code');
    }
  }
  return (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 999, backgroundColor: '#fff', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <h1>Please verify your access</h1>
      <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
        <input style={{ padding: '8px 20px', borderRadius: 12, border: '1px solid #eee' }} onChange={(e) => setAccessCode(e.target.value)} type="text" placeholder="Enter your access code" />
        <Button onClick={verifyAccess}>Verified</Button>
      </div>
    </div>
  )
}
